import { gql } from '@apollo/client'

export const FETCH_BUNDLE = gql`
  query bundle($id: ID!) {
    node(id: $id) {
      ... on Bundle {
        id
        identifier
        commercialName
        startDate
        endDate
        computedStatus
        bundleSchedules {
          id
          status
          audience
          startDate
          endDate
          consumedAt
          freedAt
          campaign {
            id
            name
          }
        }
        media {
          id
          asId
          address
          building {
            name
          }
          agglomeration {
            name
          }
          city {
            name
          }
        }
      }
    }
  }
`
